import React from 'react';

import { Skeleton } from '@rbilabs/universal-components';

import { Box, BoxProps } from 'components/ui';

export const ResponsiveCarouselSkeletonItem = React.memo(
  ({ style, width, ...props }: BoxProps & { width?: number }) => (
    <Box style={[styles.container, { width: width ?? 192 }, style]} {...props}>
      <Skeleton h="32" />
      <Skeleton.Text px="4" h="20" />
    </Box>
  )
);

const styles = {
  container: {
    backgroundColor: 'white',
    borderColor: '#E4E4E7',
    borderRadius: 4,
    borderWidth: 1,
    gap: 32,
    overflow: 'hidden' as const,
  },
};
